module.exports = __webpack_public_path__ + "img/07.6dc29950.jpg";